import Vue from 'vue'
import Router from 'vue-router'
import { publicRoute, protectedRoute } from './config'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import store from '@/store/index.js'

const routes = publicRoute.concat(protectedRoute)

Vue.use(Router)
const router = new Router({
  mode: 'history',
  linkActiveClass: 'active',
  routes: routes,
  scrollBehavior(to, from, savedPosition) {
    // 前回の位置に戻る
    if (savedPosition) {
      return savedPosition
    }
    // URLにhashが含んでいたらハッシュの位置まで移動
    if (to.hash) {
      return { selector: to.hash }
    }
    // ページの先頭に移動
    return { x: 0, y: 0 }
  },
})
// router gards
router.beforeEach((to, from, next) => {
  NProgress.start()
  //auth route is authenticated
  if (
    (store.state.auth.login.token && store.state.auth.login.expire > new Date().getTime()) ||
    to.matched.every((page) => {
      const matchesPath = (path, config) => {
        for (const i in config) {
          if (
            config[i].path === path ||
            config[i].path + '/' === path ||
            config[i].redirect === path ||
            config[i].redirect + '/' === path
          ) {
            return true
          } else if (config[i].children) {
            if (matchesPath(path, config[i].children)) {
              return true
            }
          }
        }
        return false
      }
      return matchesPath(page.path === '' ? '/' : page.path, publicRoute)
    })
  ) {
    next()
  } else {
    next({ path: '/login', query: { backuri: to.fullPath } })
  }
})

router.afterEach(() => {
  NProgress.done()
})

export default router
